export default __webpack_public_path__ + "static/media/pepe-guapo.16d73e31.svg";